export const SCOUT_SIDEBAR_SESSION_KEY_PREFIX = 'scout-sidebar-open';

export type ScoutSessionScope = {
  userId: string | number | null | undefined;
  accountId: number | null | undefined;
};

export function scoutSessionStorageKey(
  scope: ScoutSessionScope,
): string | null {
  const { userId, accountId } = scope;
  if (userId == null || userId === '' || accountId == null) {
    return null;
  }
  return `${SCOUT_SIDEBAR_SESSION_KEY_PREFIX}:${userId}:${accountId}`;
}

export type PersistedScoutSidebarOpenState = {
  isOpen: boolean;
};
